export const en = {
  centersPanel: {
    title: 'Centers',
    addCenter: 'Add center',
    focusCenter: 'Focus on center'
  },

  overviewButton: {
    title: 'Overview'
  },

  missionVisibilityButton: {
    showAllMissionsTitle: 'Show all mission routes',
    showSelectedVehicleMissionTitle: 'Show route for selected vehicle mission only'
  },

  // Common UI strings
  common: {
    notAvailable: '--',
    close: 'Close',
    clearSelection: 'Clear selection'
  },

  // Error messages
  errors: {
    httpRequestFailed: 'HTTP request failed',
    httpBadRequest: 'Bad request',
    httpUnauthorized: 'Unauthorized',
    httpForbidden: 'Forbidden',
    httpNotFound: 'Not found',
    httpInternalServerError: 'Internal server error',
    httpBadGateway: 'Bad gateway',
    httpServiceUnavailable: 'Service unavailable',
    httpGatewayTimeout: 'Gateway timeout',
    authOktaCallbackMissingCode: 'Missing Okta authorization code',
    authOktaCallbackMissingRedirectUri: 'Missing Okta redirect URI',
    authOktaCallbackMissingPendingGcsId: 'Missing pending GCS',
    authOktaCallbackGcsConfigNotFound: 'Selected GCS configuration not found',
    missionNotFound: 'No active mission found',
    unknown: 'An unknown error occurred'
  },

  // Map Markers
  mapMarkers: {
    launchpad: 'Launchpad',
    foreignAircraftId: 'ID',
    foreignAircraftAltitude: 'Altitude',
    amsl: 'AMSL'
  },

  // Sign In Page
  signIn: {
    title: 'Welcome',
    subtitle: 'Select Centers',
    signInWithOktaButton: 'Sign in with Okta'
  },

  // Header Menu
  sidePanelMenuItems: {
    signOut: 'Sign out',
    about: 'About',
    sendLogs: 'Send logs',
    trainingControls: 'Training controls',
    moreOptions: 'More options'
  },

  // About Dialog
  aboutDialog: {
    title: 'About',
    appLabel: 'ROC app'
  },

  // USS Logs Dialog
  ussLogsDialog: {
    title: 'USS Logs'
  },

  // Mission Logs Dialog
  missionLogsDialog: {
    title: 'Mission Logs'
  },

  // Training Controls Dialog
  trainingControlsDialog: {
    title: 'Training Controls',
    searchVehiclePlaceholder: 'Search vehicle',
    noVehiclesFound: 'No vehicles found',
    selectedVehicleLabel: 'Selected',
    fcLossButton: 'FC Loss',
    vehicleDisconnectionButton: 'Vehicle disconnection',
    daaButton: 'DAA',
    remoteIdFailureButton: 'Remote ID failure',
    restartVehicleButton: 'Restart vehicle',
    motorFailureButton: 'Motor failure',
    veryLowBatteryButton: 'Very low battery',
    accelVibrationsButton: 'Accel vibrations',
    geofenceBreachButton: 'Geofence breach',
    gpsDegradationButton: 'GPS degradation'
  },

  // Vehicle Panel Header
  vehiclePanelHeader: {
    pad: 'Pad',
    focusOnVehicle: 'Focus on vehicle',
    moreOptions: 'More options',
    close: 'Close'
  },

  // Vehicle Mission Label
  vehicleMissionLabel: {
    vehiclePrefix: 'Vehicle',
    missionPrefix: 'Mission'
  },

  // Preflight Panel
  preflightPanel: {
    launchpad: 'Launchpad',
    order: 'Order',
    deliveryPoint: 'Delivery point',
    packageWeight: 'Package weight',
    pickupPoint: 'Pickup point',
    distanceRoundtrip: 'Distance roundtrip',
    requiredBattery: 'Required battery',
    cancelMissionButton: 'Cancel Mission',
    takeoffButton: 'Takeoff',
    firstToDeliveryPoint: 'First order to delivery point',
    jetDelivery: 'Jet delivery',
    refly: 'Refly, the package was previously aborted.'
  },

  // Inflight Panel
  inflightPanel: {
    safeUpButton: 'Safe up',
    rtlButton: 'RTL',
    landButton: 'Land',
    ftsButton: 'FTS',
    missionLogs: 'Mission Log'
  },

  telemetry: {
    batteryPct: 'Battery (%)',
    speedMs: 'Speed (m/s)',
    speedMph: 'Speed (kt)',
    altitudeM: 'Altitude (m) AMSL',
    altitudeFt: 'Altitude (ft) AMSL'
  },

  // Logs Card
  logsCard: {
    errorsOnly: 'Errors only'
  },

  // Postflight Panel
  postflightPanel: {
    order: 'Order',
    packageWeight: 'Package weight',
    distanceTravelled: 'Total flown distance',
    batteryConsumed: 'Battery consumption',
    deliveryOutcome: 'Delivery outcome',
    delivered: 'Delivered',
    canceled: 'Canceled',
    aborted: 'Aborted',
    other: 'Other'
  },

  // Vehicle Status (includes all mission statuses and vehicle states)
  vehicleStatus: {
    pendingPreflight: 'Pending preflight',
    preflight: 'Preflight',
    readyForTakeoff: 'Ready for takeoff',
    takingOff: 'Taking Off',
    inflightToPickup: 'En route to pickup',
    pickingUp: 'Picking up',
    waitingForPackageLoadedConfirmation: 'Waiting for Package Loaded',
    inflightToDestination: 'En route to delivery',
    inflightHome: 'Returning',
    landingHome: 'Landing',
    waitingForWireDropConfirmation: 'Delivering',
    performingWireDrop: 'Delivering',
    hoveringPaused: 'Hovering paused',
    safingUp: 'Safing up',
    safedUp: 'Safed up',
    descending: 'Descending',
    descended: 'Descended',
    abortHome: 'Aborting home',
    fcRtl: 'RTL',
    emergencyLanding: 'Emergency landing',
    rcInControl: 'RC in control',
    mcPostflight: 'MC postflight',
    executingFallbackMission: 'Fallback',
    fcLoss: 'FC Loss',
    postflight: 'Pending postflight',
    parachuteTriggered: 'FTS Triggered',
    vehicleDisconnected: 'Disconnected',
    pendingPreparation: 'Pending preparation',
    pendingMission: 'Pending mission'
  },

  // Center panel menu
  centersPanelMenuItems: {
    ussLogs: 'USS logs',
    confirmCloseService: 'Close service',
    confirmOpenService: 'Open service',
    removeCenter: 'Remove center'
  },

  // Center status titles
  centerStatusTitles: {
    unknown: 'Unknown',
    centerOpen: 'Open',
    centerOpeningChecklist: 'Opening checklist',
    centerOpenServiceClosed: 'Service closed',
    centerOpenCanBeClosed: 'Can be closed',
    centerClosingChecklist: 'Closing checklist',
    centerClosed: 'Closed'
  },

  // Connection status titles
  connectionStatusTitles: {
    disconnected: 'Disconnected',
    connecting: 'Connecting...',
    connected: 'Connected',
    connectionError: 'Connection Error'
  },

  simulationIndicator: {
    title: 'Simulated vehicle',
    label: 'S'
  },

  // Vehicle menu items
  vehiclePanelMenuItems: {
    showVersions: 'Show versions',
    missionLogs: 'Mission logs',
    missionNote: 'Mission note',
    discrepancyReport: 'Discrepancy report'
  },

  // In-app notificatiozns
  inAppNotifications: {
    serverConnectionLostBody: 'Server connection lost',
    serverConnectionRegainedBody: 'Server connection regained',
    ussServerConnectionRegainedBody: 'USS server connection regained',
    ussServerConnectionLostBody: 'USS server connection lost',
    centerUnitSystemsInconsistentTitle: 'Unit system mismatch detected',
    centerUnitSystemsInconsistentBody:
      'Unit system mismatch detected Center(s) {imperialCenters} use imperial units, while center(s) {metricCenters} use metric units.',
    foreignAircraftGroundStopAlertBody: 'Ground Stop alert - Aircraft intruding',
    foreignAircraftWellClearAlertBody: 'Well Clear alert - Aircraft intruding',
    sendLogsSuccessBody: 'Logs sent successfully',
    sendLogsErrorBody: 'Failed to send logs'
  },

  // Mission failure mode display names
  missionFailureModes: {
    rtl: 'RTL',
    safingUp: 'Safing Up',
    safedUp: 'Safed Up',
    descending: 'Descending',
    descended: 'Descended',
    emergencyLand: 'Emergency Landing',
    fcRtl: 'FC RTL',
    fcLoss: 'FC Loss',
    ftsTriggered: 'FTS Triggered',
    unknownVehicleDisconnected: 'Vehicle Disconnected',
    vehicleReconnected: 'Vehicle Reconnected',
    landingIn: 'Landing in '
  },

  // Another Connection Detected Dialog
  anotherConnectionDetectedDialog: {
    title: 'Another Connection Detected',
    body: 'Another connection to {gcsId} has been detected. Would you like to keep the previous connection or use this one?',
    keepPreviousButton: 'Keep previous',
    useHereButton: 'Use here'
  },

  // Confirm Cancel Mission Dialog
  confirmCancelMissionDialog: {
    title: 'Cancel Mission',
    body: 'Mission {missionId} for vehicle {vehicleId} will be canceled.',
    cancelMissionButton: 'Cancel mission'
  },

  // Confirm FTS Dialog
  confirmFtsDialog: {
    title: 'Initiate FTS',
    body: 'The mission will be terminated for vehicle {vehicle} and the vehicle’s parachute will be triggered.',
    ftsButton: 'FTS'
  },

  // Confirm RTL Dialog
  confirmRtlDialog: {
    title: 'Initiate RTL',
    body: 'Vehicle {vehicle} will return to the launchpad.',
    rtlButton: 'RTL'
  },

  // Confirm Emergency Land Dialog
  confirmEmergencyLandDialog: {
    title: 'Initiate Emergency Landing',
    body: 'Vehicle {vehicle} will land at a nearby safe landing point.',
    landButton: 'Emergency land'
  },

  // Confirm Safe Up Land Dialog
  confirmSafeUpLandDialog: {
    title: 'Initiate Safe Up',
    body: 'Vehicle {vehicle} will head to a nearby safe landing point and hover before landing.',
    safeUpButton: 'Safe up'
  },

  // Confirm Sign Out Dialog
  confirmSignOutDialog: {
    title: 'Sign Out',
    body: 'Signing out will abort all active missions in “My Fleet”.',
    signOutButton: 'Sign out'
  },

  // Submit Discrepancy Report Dialog
  submitDiscrepancyReportDialog: {
    title: 'Discrepancy Report',
    reportPlaceholder: 'Please describe the issue with as much detail as possible. ',
    submitDiscrepancyReportButton: 'Save report'
  },

  // Set Mission Note Dialog
  setMissionNoteDialog: {
    title: 'Mission Note',
    noteLabel: 'Note',
    notePlaceholder: 'Please enter the mission note.',
    setMissionNoteButton: 'Save note'
  },

  // Vehicle Module Versions Dialog
  vehicleModuleVersionsDialog: {
    title: 'Vehicle Versions',
    module: 'Module',
    displayName: 'Display name',
    version: 'Version',
    lastUpdate: 'Last update',
    emptyState: 'No module versions found'
  },

  // Confirm Close Service Dialog
  confirmCloseServiceDialog: {
    title: 'Close Service',
    body: 'Closing the service at {nameCode} will prevent new missions from being assigned. Active missions will not be affected.',
    confirmCloseServiceButton: 'Close service'
  },

  // Confirm Open Service Dialog
  confirmOpenServiceDialog: {
    title: 'Open Service',
    body: 'Opening the service at {nameCode} will allow incoming orders.',
    confirmOpenServiceButton: 'Open service'
  },

  // Confirm Remove Center Dialog
  confirmRemoveCenterDialog: {
    title: 'Remove Center',
    body: 'Removing {nameCode} will abort all active missions in “My Fleet” that belong to this center.',
    removeCenterButton: 'Remove'
  },

  // Approve Takeoff Dialog
  confirmTakeoffDialog: {
    title: 'Takeoff',
    body: 'Vehicle {vehicle} will take off from launchpad {launchpadLetter} at {nameCode}',
    launchpadLabel: 'Launchpad',
    confirmTakeoffButton: 'Takeoff'
  },

  // Side Panel
  sidePanel: {
    allVehicles: 'All fleet',
    myVehicles: 'My fleet',
    inflightCount: '{count} in flight',
    emptyState: 'No vehicles are currently airborne or in preflight'
  },

  // Units
  units: {
    weightKg: '{value} kg',
    weightLb: '{value} lb',
    temperatureC: '{value}°C',
    speedMs: '{value} m/s',
    speedMph: '{value} kt',
    percentage: '{value}%',
    distanceM: '{value} m',
    distanceKm: '{value} km',
    distanceNM: '{value} NM',
    distanceFt: '{value} ft',
    altitudeM: '{value}m',
    altitudeFt: '{value} ft'
  }
} as const;

export type Locale = typeof en;
